// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7948) return "static/chunks/2cca2479-e1b57d2953410fa9.js";
	if (chunkId === 8780) return "static/chunks/8780-b29b61a3bb066c7d.js";
	if (chunkId === 2490) return "static/chunks/2490-89b9c9e33f779c0d.js";
	if (chunkId === 6388) return "static/chunks/6388-a88c9ee0d7e108f6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"780":"6c541edd8de10aba","5403":"6ddac2eef1e03b16","8385":"6ce6ffd000cca5dd","9642":"fdde1a0fc50c2204"}[chunkId] + ".js";
};